import React, { Component } from "react";
import BreadCumb from "./../component/Department/BreadCumb";
import BreadCrumbOwn from "../component/Essentials/BreadCrumbOwn";
import { Grid, Container, Typography } from "@material-ui/core";

export default class ContactUsContainer extends Component {
  render() {
    return (
      <div>

        <BreadCrumbOwn title="Contact Us" />
        <Container style={{ minHeight: '600px' }}>
          <br></br>
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <ul>
                  <li style={{ paddingBottom: "", listStyle: 'none', fontSize: '1.2em', marginLeft: "-40px" }}>
                    <Typography variant="h5" style={{ margin: "1em 0", fontWeight: 700 }} gutterBottom>
                      Postal Address
                    </Typography>
                    <Typography variant="body1">
                      Rangia College
                      <br />
                      Rangia,Kamrup(R),Assam (India)
                      <br />
                      Pin 781354
                      <br />
                      Phone:{" "}
                      <a href={`tel:+919101829733`}>+91 91018 29733</a>
                      {", "}
                      <a href={`tel:+917002270875`}>+91 70022 70875</a>
                      <br />
                      Email:{" "}
                      <a href={`mailto:principal.rangiacollege@gmail.com`}>
                      principal.rangiacollege@gmail.com
                      </a>
                      <br />
                      Webmail:{" "}
                      <a href={`mailto:principal.rangiacollege@gmail.com`}>
                      principal.rangiacollege@gmail.com
                      </a>
                      <br />
                      Website:{" "}
                      <a href={`https://rangiacollege.ac.in/`}>
                        https://rangiacollege.ac.in/
                      </a>{" "}
                      <br />
                      
                    </Typography>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3572.
                    8824481543834!2d91.61422850000001!3d26.427269799999994!2m3!1f0!2f0!3f0!
                    3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375bb346c737e741%3A0x401ed6fba0d196fe!
                    2sRangia%20College!5e0!3m2!1sen!2sin!4v1774939761752!5m2!1sen!2sin"
                  width="600"
                  height="400"
                  style={{ border: 0, maxWidth: '100%' }}
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>

              </Grid>
            </Grid>

          </div>
        </Container>
      </div>
    );
  }
}
